import { IAccessToken } from '@/store/models/auth.model';
import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';
import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';
import {
  ISetCurrentSupportUserAction,
  IUpdateSupportUserMetadataAction,
  IUpdateSupportUserMetadataSuccessAction,
  IUpdateSupportUserMetadataFailAction,
  IChangePasswordAction,
  IChangePasswordSuccessAction,
  IChangePasswordFailAction,
  IShouldChangePasswordAction,
} from '@/features/dashboard-users/store/types/support-user.types';
import { Auth2FaActionTypes, T2FaAction } from '@/features/2fa/store/types/auth2Fa.types';
import { IState } from '@/store/types/search.types';

export enum BaseAuthActionTypes {
  FETCH_ACCESS_TOKEN = 'AUTH.FETCH_ACCESS_TOKEN',
  FETCH_ACCESS_TOKEN_SUCCESS = 'AUTH.FETCH_ACCESS_TOKEN_SUCCESS',
  FETCH_ACCESS_TOKEN_FAIL = 'AUTH.FETCH_ACCESS_TOKEN_FAIL',

  AUTH_LOGOUT = 'AUTH.AUTH_LOGOUT',

  REFRESH_TOKEN = 'AUTH.REFRESH_TOKEN',
  REFRESH_TOKEN_FAIL = 'AUTH.REFRESH_TOKEN_FAIL',
  REFRESH_TOKEN_SUCCESS = 'AUTH.REFRESH_TOKEN_SUCCESS',
}

export const AuthActionTypes = {
  ...BaseAuthActionTypes,
  ...Auth2FaActionTypes,
};

export interface IFetchAccessTokenAction extends IBaseAction {
  type: typeof AuthActionTypes.FETCH_ACCESS_TOKEN;
}

export interface IFetchAccessTokenSuccessAction extends IBaseAction {
  type: typeof AuthActionTypes.FETCH_ACCESS_TOKEN_SUCCESS;
  token: IAccessToken;
  currentSupportUser?: ISupportUser;
}

export interface IFetchAccessTokenFailAction extends IBaseAction {
  type: typeof AuthActionTypes.FETCH_ACCESS_TOKEN_FAIL;
  error: TAppError;
}

export interface IAuthLogout extends IBaseAction {
  type: typeof AuthActionTypes.AUTH_LOGOUT;
}

export interface IRefreshTokenAction extends IBaseAction {
  type: typeof AuthActionTypes.REFRESH_TOKEN;
}

export interface IRefreshTokenSuccessAction extends IBaseAction {
  type: typeof AuthActionTypes.REFRESH_TOKEN_SUCCESS;
  accessToken: IAccessToken;
}

export interface IRefreshTokenFailAction extends IBaseAction {
  type: typeof AuthActionTypes.REFRESH_TOKEN_FAIL;
  error: TAppError;
}
export type TAuthAction =
  | IFetchAccessTokenAction
  | IFetchAccessTokenSuccessAction
  | IFetchAccessTokenFailAction
  | IAuthLogout
  | IRefreshTokenAction
  | IRefreshTokenSuccessAction
  | IRefreshTokenFailAction
  | ISetCurrentSupportUserAction
  | IUpdateSupportUserMetadataAction
  | IUpdateSupportUserMetadataFailAction
  | IUpdateSupportUserMetadataSuccessAction
  | T2FaAction
  | IChangePasswordAction
  | IChangePasswordSuccessAction
  | IChangePasswordFailAction
  | IShouldChangePasswordAction;

export interface IAuthState extends IBaseState {
  token?: IAccessToken;
  currentSupportUser?: IState<ISupportUser> & { shouldChangePassword?: boolean };
  auth2Fa?: {
    credentials: string;
    challenge?: string;
  };
}
